module.exports = __webpack_public_path__ + "static/img/door.f81cf8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/door.png
// module id = SX0F
// module chunks = 1